import controller from './droit.controller';
import template from './droit.html';
import './droit.scss';

export default {
	template,
	bindings: {
		form:       '<?',
		node:       '<ngModel',
		disabled:   '<?ngDisabled',
		onChange:   '&',
		hideRead:   '<',
		hideCreate: '<',
		hideModify: '<',
		hideDelete: '<',
	},
	controller,
	require:  {
		oo:          '^^?ooAdmin',
		ngModelCtrl: '?ngModel',
	},
};
